export const getters = {
  getTeams($state) {
    return Object.values($state.records).sort((a, b) => a.id - b.id);
  },
  getTeamById: $state => id => {
    return (
      Object.values($state.records).find(record => record.id === Number(id)) ||
      {}
    );
  },
  getMyTeams($state, $getters) {
    return $getters.getTeams.filter(team => {
      const { is_member: isMember } = team;
      return isMember;
    });
  },
  getManageableTeams($state, $getters) {
    return $getters.getTeams.filter(team => team.can_manage_members);
  },
  getManageableTeamById: ($state, $getters) => id => {
    return (
      $getters.getManageableTeams.find(team => team.id === Number(id)) || {}
    );
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getTeam: $state => id => {
    const team = $state.records[id];
    return team || {};
  },
};
